module.exports = __webpack_public_path__ + "static/img/ma4.8b0a14e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma4.gif
// module id = GacS
// module chunks = 1